export const INTERACTIVE_ELEMENT_SELECTOR =
  'a[href], button, input, label, select, textarea, [role=button], [role=link], [role=checkbox], [role=switch], [role=menuitem], [role=tab]';
